import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type {
  TermsException,
  TermsExceptionsFilter,
} from "../@types/services/TermsException";
import type { Vendor } from "../@types/services/Vendor";
import { api } from "./api";

const API_BASE_URL = "/api/v3/terms_exceptions";

export type NewTermsExceptionData = {
  vendor_id: Vendor["id"];
  reason: string;
  file_attachments: string[];
};

export type UpdateTermsExceptionData = {
  reason: string;
};

export const createTermsException = async (
  data: NewTermsExceptionData,
): Promise<TermsException> => {
  const response = await api.post<TermsException>("/", data, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const deleteTermsException = async (id: string): Promise<void> => {
  await api.delete(`/${id}`, {
    baseURL: API_BASE_URL,
  });
};

export const fetchTermsExceptions = async ({
  filters,
  ...rest
}: ApiListRequest<TermsExceptionsFilter> = {}): Promise<
  ApiListResponseV3<TermsException>
> => {
  const response = await api.get<ApiListResponseV3<TermsException>>("/", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });

  return response.data;
};

export const fetchTermsException = async (
  id: string,
): Promise<TermsException> => {
  const response = await api.get<TermsException>(`/${id}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const updateTermsException = async (
  id: string,
  data: UpdateTermsExceptionData,
): Promise<TermsException> => {
  const response = await api.patch<TermsException>(`/${id}`, data, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};
